import apiClient from './apiClient';

const Url = `/document`;

export const singleFileUpload = async (payload, props) => {
  try {
    if (!payload?.file) return false;

    const formData = new FormData();
    formData.append("file", payload.file);
    if (payload.customerId) formData.append("customerId", payload.customerId);
    if (payload.type) formData.append("type", payload.type);
    if (payload.category) formData.append("category", payload.category);
    if (payload.module) formData.append("module", payload.module);
    if (payload.recordId) formData.append("recordId", payload.recordId);

    const response = await apiClient.post(`${Url}/`, formData);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    }
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const removeFile = async (payload, props) => {
    console.log('Remove File', props, payload);
    try{
        if(!payload && payload.documentId) return false;
        let response = await apiClient.delete(`${Url}/?documentId=${payload.documentId}`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}
